
  import { mapGetters } from "vuex"
  import TrackComponent from "../common/TrackComponent"
  import Observer from "../common/ObserverComponent"

  export default {
    name: "CatalogSlugPageView",
    components: {
      Observer,
      TrackComponent,
    },
    props: {},
    data() {
      return {
        detailsDict: {
          author: "Автор",
          genres: "Жанры",
          moods: "Настроение",
          themes: "Тематика",
          main_instruments: "Инструменты",
          main_key: "Основной ключ",
          tonality: "Тональность"
        },
        iconsList: ["favorites", "download", "shared", "cart"]

      };
    },
    computed: {
      ...mapGetters('tracks', ['track', 'tracksMoreLikeThis', 'nextPageUrl']),
      ...mapGetters('user', ['isModerator']),
    },
    methods: {
      getDetailsTrack(key) {
        if (key === 'author') {
          return this.track.author_brand || this.track[key]
        }

        return Array.isArray(this.track[key]) ? this.track[key].join(', ') : this.track[key]
      },
      async intersected() {
        if (this.nextPageUrl) {
          await this.$store.dispatch('tracks/loadingTracksMoreLikeThis', {url: this.nextPageUrl})
        }
      }
    }
  }
